import {Injectable} from '@angular/core';
import {UrlService} from "../common/url.service";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http: HttpClient, private urlService: UrlService) { }

    loadRecommendedProducts(): Promise<any> {
        return this.http.get(this.urlService.buildCartUrl("/manage/updateSalesData/")).toPromise();
    }

    clearProductCache(): Promise<any> {
        return this.http.get(this.urlService.buildCartUrl("/manage/clearProducts")).toPromise();
    }

    clearTranslationCache(): Promise<any> {
        return this.http.get(this.urlService.buildCartUrl("/manage/clearTranslations")).toPromise();
    }

    purgeShoppingCarts(): Promise<any> {
        return this.http.get(this.urlService.buildCartUrl("/manage/purgeCarts")).toPromise();
    }

    logProductInfo(country: string, warehouse: string, language: string, usanaId: string): Promise<any> {
        let params = new HttpParams();
        params = params.set("country", country);
        params = params.append("warehouse", warehouse);
        params = params.append("language", language);
        params = params.append("usanaId", usanaId);
        return this.http.get(this.urlService.buildCartUrl("/manage/logProductInfo/"), {params}).toPromise();
    }

    clearAllQuartzTasks(adminPassword: string): Promise<any> {
        let params = new HttpParams();
        params = params.set("adminPassword", adminPassword);
        return this.http.get(this.urlService.buildCartUrl("/manage/clearQuartzTasks/"), {params}).toPromise();
    }

    clearQuartzTrigger(adminPassword: string, schedulerTrigger: string, trigger: string): Promise<any> {
        let params = new HttpParams();
        params = params.set("adminPassword", adminPassword);
        params = params.append("schedulerTrigger", schedulerTrigger);
        params = params.append("trigger", trigger);
        return this.http.get(this.urlService.buildCartUrl("/manage/clearQuartzTasks/"), {params}).toPromise();
    }

    clearQuartzJob(adminPassword: string, schedulerJob: string, job: string): Promise<any> {
        let params = new HttpParams();
        params = params.set("adminPassword", adminPassword);
        params = params.append("schedulerJob", schedulerJob);
        params = params.append("job", job);
        return this.http.get(this.urlService.buildCartUrl("/manage/clearQuartzTasks/"), {params}).toPromise();
    }

    singleProductLoadByCountry(country: string, productId: string): Promise<any> {
        return this.http.get(this.urlService.buildCartUrl("/productFeed/singleProductLoad/"+productId+"/"+country), {}).toPromise();
    }

    syncProductsByCountryAndProductId(country: string, productId: string): Promise<any> {
        return this.http.get(this.urlService.buildCartUrl("/productFeed/syncProducts/"+country+"/"+productId), {}).toPromise();
    }

    syncProductsByCountry(country: string): Promise<any> {
        return this.http.get(this.urlService.buildCartUrl("/productFeed/syncProducts/"+country), {}).toPromise();
    }

    syncProducts(): Promise<any> {
        return this.http.get(this.urlService.buildCartUrl("/productFeed/syncProducts"), {}).toPromise();
    }
}
